import { nationalityFlagMarkup } from '../components/nationalityFlag.js';
import { standingsRankCellHtml } from '../standings/standingsTableMarkup.js';

export interface RaceResultsRow {
  rank: number;
  driverName: string;
  carName: string;
  nationality?: string;
  diceRolls: number;
  overtakesSucceeded: number;
  overtakesCountered: number;
}

function escapeHtml(value: string): string {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
}

export function formatDiceRollsLabel(count: number): string {
  return `${count} lancer${count > 1 ? 's' : ''}`;
}

export function formatOvertakesSucceededLabel(count: number): string {
  return `${count} dépassement${count > 1 ? 's' : ''} réussi${count > 1 ? 's' : ''}`;
}

export function formatOvertakesCounteredLabel(count: number): string {
  return `${count} dépassement${count > 1 ? 's' : ''} contré${count > 1 ? 's' : ''}`;
}

function raceResultsStatCell(
  count: number,
  title: string,
  modifierClass: string,
  ariaLabel: string
): string {
  return `<td class="play-race-results-cell play-race-results-cell--stat ${modifierClass}" title="${escapeHtml(title)}" aria-label="${escapeHtml(ariaLabel)}">
          <span class="play-race-results-stat-count">${count}</span>
        </td>`;
}

export function buildRaceResultsTableRows(rows: RaceResultsRow[]): string {
  return rows
    .map((row) => {
      const flag = row.nationality
        ? nationalityFlagMarkup(row.nationality, { className: 'play-race-results-flag' })
        : '';
      const podiumClass =
        row.rank === 1
          ? ' play-race-results-row--gold'
          : row.rank === 2
            ? ' play-race-results-row--silver'
            : row.rank === 3
              ? ' play-race-results-row--bronze'
              : '';
      return `<tr class="play-race-results-row${podiumClass}">
        <td class="play-race-results-cell play-race-results-cell--rank">${standingsRankCellHtml(row.rank)}</td>
        <td class="play-race-results-cell play-race-results-cell--driver">
          <span class="play-race-results-driver">
            ${flag}
            <span class="play-race-results-driver-text">
              <span class="play-race-results-driver-name">${escapeHtml(row.driverName)}</span>
              <span class="play-race-results-car-name">${escapeHtml(row.carName)}</span>
            </span>
          </span>
        </td>
        ${raceResultsStatCell(
          row.diceRolls,
          formatDiceRollsLabel(row.diceRolls),
          'play-race-results-stat--dice',
          formatDiceRollsLabel(row.diceRolls)
        )}
        ${raceResultsStatCell(
          row.overtakesSucceeded,
          formatOvertakesSucceededLabel(row.overtakesSucceeded),
          'play-race-results-stat--overtake-ok',
          formatOvertakesSucceededLabel(row.overtakesSucceeded)
        )}
        ${raceResultsStatCell(
          row.overtakesCountered,
          formatOvertakesCounteredLabel(row.overtakesCountered),
          'play-race-results-stat--overtake-block',
          formatOvertakesCounteredLabel(row.overtakesCountered)
        )}
      </tr>`;
    })
    .join('');
}
